import React from 'react';
import 'src/pages/Analytics/Analytics.css';

export const AnalyticsCardHeader = ({ icon, count, title, dateRange, customIcon, overview, hideRange }) => {
  let active, completed;
  if (overview) {
    active = overview.active_popins;
    completed = overview.completed_popins;
  }

  let range = '(All Time)';
  if (dateRange.value === 52) {
    range = '(Last Year)';
  } else if (dateRange.value === 12) {
    range = `(Last ${dateRange.value} Weeks)`;
  }

  return (
    <div className="row no-gutters analytics-card-header align-items-start">
      <div className="icon-container">
        { customIcon
          ? <div style={ customIcon } className="custom-icon" />
          : icon
            ? <i className="material-icons">{ icon }</i>
            : null
        }
      </div>
      <div className="title-container">
        <div>
          { (count !== null && count !== undefined) && (
            <span className="text-title count">{ count }</span>
          ) }
          <span className="text-title title">{ title }</span>
          { !hideRange && <span className="date-range-label subtitle">{ range }</span> }
          { overview
            ? (
              <span className="overview-count-container">
                <span className="overview-count"> { active } </span>
                <span>Active</span>
                <span className="overview-count"> { completed } </span>
                <span>Completed</span>
              </span>
            ) : null
          }
        </div>
      </div>
    </div>
  );
};
